"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UserCircleOutline_1 = __importDefault(require("../icons/generated/UserCircleOutline"));
var ProfileAvatarWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  height: 56px;\n  color: ", ";\n  svg {\n    margin-right: 20px;\n    fill: white;\n    width: 56px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  height: 56px;\n  color: ", ";\n  svg {\n    margin-right: 20px;\n    fill: white;\n    width: 56px;\n  }\n"])), function (props) { return props.theme.colours.tile.headerColor; });
ProfileAvatarWrapper.displayName = 'ProfileAvatarWrapper';
var UserDetails = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
UserDetails.displayName = 'UserDetails';
var UserName = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: 52px;\n  font-size: 40px;\n  margin-top: -4px;\n"], ["\n  line-height: 52px;\n  font-size: 40px;\n  margin-top: -4px;\n"])));
UserName.displayName = 'UserName';
var UserAccount = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  line-height: 20px;\n  font-size: 16px;\n  color: ", ";\n  margin-top: -8px;\n"], ["\n  line-height: 20px;\n  font-size: 16px;\n  color: ", ";\n  margin-top: -8px;\n"])), function (props) { return props.theme.colours.tile.headerColor; });
UserAccount.displayName = 'UserAccount';
var ProfileAvatar = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, company = _a.company;
    return (react_1.default.createElement(ProfileAvatarWrapper, null,
        react_1.default.createElement(UserCircleOutline_1.default, null),
        react_1.default.createElement(UserDetails, null,
            react_1.default.createElement(UserName, null,
                firstName,
                " ",
                lastName),
            react_1.default.createElement(UserAccount, null, company))));
};
ProfileAvatar.displayName = 'ProfileAvatar';
exports.default = ProfileAvatar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
